import React from '../helpers/react';
import { trigger } from '../helpers/events.js';
import classList from 'ereader-core/dist/classList.js';
import {getHookClass} from '../helpers/cssHooks.js';

export const ErrorDialog = React.createClass({
    triggerCTA : function() {
        trigger('networkErrorCTA');
    },

    render :  function() {
        const header = (this.props.title) ?
            <header key='header'><h3>{this.props.title}</h3></header> : '';

        let mainClass = classList('error-wrapper', getHookClass('ErrorDialog'));
        let getDef = this.props.getDef;

        return (
            <section className={mainClass}>
                { header }
                <section className='error-dialog'>
                    <div className="error-title-icon">
                        <div className='title'>
                            <div className="error-icon"></div>
                            <div className="title-text">{getDef('error.network-title')}</div>
                        </div>
                    </div>
                    <button className='simple-button cta' onClick={this.triggerCTA}>{getDef('error.reload-btn')}</button>
                </section>
            </section>
        )
    }
});

export default ErrorDialog;



// WEBPACK FOOTER //
// ./src/components/ErrorDialog.js